import React, { ReactNode } from "react";

export interface ProviderProps {
  children: ReactNode[] | ReactNode;
  services: Array<React.ComponentType<any>>;
}

export default function ServiceProvider({ children, services }: ProviderProps): JSX.Element {
  return services
    .reverse()
    .reduce((wrapped, Service) => <Service>{wrapped}</Service>, <div>{children}</div>);
}
